module.exports = __webpack_public_path__ + "static/media/linkedin.619231ff.svg";